import React, { Component } from 'react'
import capitalize from 'lodash/capitalize'
import startCase from 'lodash/startCase'
import { NavLink } from 'react-router-dom'

import anonymousUser from '../../../assets/images/anonymous-user.svg'

import { User } from '../../../core/types'

export interface Props {
  user: User
  context: string
}

export class AdminBannerAvatar extends Component<Props> {
  static displayName = 'AdminBannerAvatar'

  render() {
    const { user, context } = this.props
    const { name, id, photo } = user

    return (
      <div
        data-test="admin-banner-avatar"
        className="user-banner__avatar user-banner__avatar--admin"
      >
        {photo ? (
          <img
            className="user-banner__avatar-image"
            alt=""
            src={`${photo.url}`}
          />
        ) : (
          <img
            className="user-banner__avatar-image"
            alt=""
            src={anonymousUser}
          />
        )}
        <NavLink
          className="user-banner__context-pill"
          data-test="user-banner-avatar-link"
          to={`/admins/${id}`}
        >
          {context}
        </NavLink>
        <div className="user-banner__avatar-name">
          {startCase(capitalize(name))}
        </div>
        <p className="user-banner__avatar-user-id">{`ID ${id}`}</p>
      </div>
    )
  }
}
